import { useSyncExternalStore } from "react";
import { densityPref } from "./prefs";

/**
 * Reads a pixel-valued CSS custom property from :root (e.g. "--row-h") and re-reads it when the
 * density preference or the pointer type changes, so virtualised lists stay on the real row height.
 */
export function useCssPx(name: string, fallback: number): number {
  return useSyncExternalStore(
    (cb) => {
      const off = densityPref.subscribe(() => requestAnimationFrame(cb));
      const mq = window.matchMedia("(pointer: coarse)");
      mq.addEventListener("change", cb);
      return () => {
        off();
        mq.removeEventListener("change", cb);
      };
    },
    () => {
      const v = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name));
      return Number.isFinite(v) && v > 0 ? v : fallback;
    },
    () => fallback,
  );
}
